/** What a call on the events link may carry: `heard` runs whenever the server sends bytes. */
export type HeardContext = { heard?: () => void };

/** The response with each chunk of an event stream reported as it arrives. oRPC's keepalive pings
 * are comments no reader of the stream ever sees, so only the bytes show the line is alive. */
export function tapEventStream(response: Response, heard: (() => void) | undefined): Response {
  heard?.();
  const isStream = (response.headers.get("content-type") ?? "").startsWith("text/event-stream");
  if (!heard || !response.body || !isStream) return response;
  const tapped = response.body.pipeThrough(
    new TransformStream<Uint8Array, Uint8Array>({
      transform(chunk, controller) {
        heard();
        controller.enqueue(chunk);
      },
    }),
  );
  return new Response(tapped, {
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
  });
}
